import { Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { merge, map, startWith } from 'rxjs';
import { ShopService } from '@app/services/shops/shop.service';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';
import { OrderEditingService } from '../../order-editing.service';

@Component({
  selector: 'order-editing-preview',
  standalone: false,
  templateUrl: './order-editing-preview.component.html',
  styleUrl: './order-editing-preview.component.scss',
})
export class OrderEditingPreviewComponent {
  destroyRef = inject(DestroyRef);

  mode = signal<'mobile' | 'desktop'>('desktop');

  private formValue = toSignal(
    merge(
      this.orderEditingService.form.valueChanges.pipe(startWith(null)),
      this.orderEditingService.loadedConfig$,
    ).pipe(
      map(() => this.orderEditingService.form.value),
      takeUntilDestroyed(this.destroyRef),
    ),
    { initialValue: this.orderEditingService.form.value },
  );

  constructor(
    private orderEditingService: OrderEditingService,
    public shopService: ShopService,
  ) {}

  template = computed(() => this.formValue()?.template as OrderEditing.Config['template'] | undefined);

  isOrderEditingDisplayed = computed(() => this.template()?.edits?.isDisplayed ?? false);

  isAddressValidationEnabled = computed(() => (this.template() as any)?.addressValidation?.enabled ?? false);

  isShippingMethodSelectionEnabled = computed(() => this.template()?.settings?.shippingRecalculation?.enabled ?? false);
}
